import { IsBoolean, IsNotEmpty, IsOptional, IsString } from 'class-validator';

export class ValidateDeliveryItemDto {
  @IsString()
  @IsNotEmpty()
  batchNumber!: string;

  /** Required unless hasNoExpiry is true (XOR enforced server-side). */
  @IsString()
  @IsOptional()
  expiryDate?: string | null;

  @IsBoolean()
  @IsOptional()
  hasNoExpiry?: boolean;
}
